import { useEffect, useRef, useState } from 'react';
import { t } from '@lingui/macro';
import _ from 'lodash';
import LinearProgress from '@material-ui/core/LinearProgress';
import { SITE_IMPORT_ERROR_LOG_FIELD, SITE_IMPORT_STATUS_MAP, SITE_IMPORT_STATUSES } from './SiteAdminConstants';
import { useDataService } from '../../../services/ApiDataService';

const importStatusApiUrl = '/ipm/v1/sitesImport/importStatus';
const statusCheckIntervalMs = 500;
const progressText = t`Import in progress`;

export default function ImportDialogProgress({ classes, initialImportState, gridRefresherFunc }) {
    const dataService = useDataService();
    const [loading, setLoading] = useState(true);
    const [importState, setImportState] = useState({});
    const [importStateText, setImportStateText] = useState('');
    const statusCheckInterval = useRef(null);

    const clearStatusCheck = () => {
        if (statusCheckInterval?.current) {
            clearInterval(statusCheckInterval.current);
        }
    };

    const importStateToText = (latestImportState) => {
        if (_.isEmpty(latestImportState)) {
            return null;
        }

        return latestImportState.status !== SITE_IMPORT_STATUSES.PROCESSING
            ? `${SITE_IMPORT_STATUS_MAP[latestImportState.status]}: ${latestImportState.message}`
            : latestImportState.message;
    };

    const statusCheck = (importId) => {
        if (_.isEmpty(importId)) {
            return;
        }

        return dataService.get(importStatusApiUrl, { id: importId }).then((response) => {
            setImportState(response);
            setImportStateText(importStateToText(response));

            const { status } = response;
            if (status === SITE_IMPORT_STATUSES.PARTIAL_SUCCESS || status === SITE_IMPORT_STATUSES.FAILED) {
                setImportState({
                    ...response,
                    errors: response[SITE_IMPORT_ERROR_LOG_FIELD],
                });
            }

            if (status !== SITE_IMPORT_STATUSES.PROCESSING) {
                setLoading(false);
                clearStatusCheck();
                gridRefresherFunc();
            }

            return response;
        });
    };

    useEffect(() => {
        if (_.isEmpty(initialImportState) || !_.isEmpty(statusCheckInterval.current)) {
            return;
        }

        setImportState(initialImportState);
        setImportStateText(importStateToText(initialImportState));

        if (initialImportState.status !== SITE_IMPORT_STATUSES.FAILED) {
            setImportStateText(progressText);

            statusCheckInterval.current = setInterval(() => statusCheck(initialImportState.id), statusCheckIntervalMs);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialImportState]);

    return (
        <div className={classes.statusContainer}>
            {loading && <LinearProgress />}
            <div className={`${classes.statusTextContainer} ${_.get(importState || {}, 'status', '')}`}>
                {importStateText}
            </div>
            {importState && importState.errors && (
                <div>
                    {_.map(importState.errors, (error) => {
                        return <div key={_.uniqueId()}>{error}</div>;
                    })}
                </div>
            )}
        </div>
    );
}
